import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { NgxPermissionsModule } from "ngx-permissions";
import { PagoRoutingModule} from "./pago.routing.modules";

import { pagoEModule } from "../../../forms/pago/pagoE.module";
import { PagoComponent } from "./pago.component";


@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        BotonToggleModule,
        MaterialModule,
        PagoRoutingModule,
        pagoEModule
    ],
    declarations: [
        PagoComponent      
    ],
    providers: [
    ],
    entryComponents: [
    ] 
})
export class PagoModule { }